export const GET_ALL_GEOGRAPHIES = "GET_ALL_GEOGRAPHIES";
export const REMOVE_A_USER = "REMOVE_A_USER";
export const UPDATE_A_USER = "UPDATE_A_USER";
export const RESET_DATA = "RESET_DATA";
export const START_LOADING_GEOGRAPHIES = "START_LOADING_GEOGRAPHIES";
export const STOP_LOADING_GEOGRAPHIES = "STOP_LOADING_GEOGRAPHIES";
export const ERROR_LOADING_GEOGRAPHIES = "ERROR_LOADING_GEOGRAPHIES";
